import PatientsDemographic from "components/PatientsDemographic";
import React, { useState } from "react";
import { Button, Col, FormGroup, Input, InputGroup, Row } from "reactstrap";
import doubleArrow from "../../../../../assets/icon/double-arrow-down.svg";
import resetIcon from "../../../../../assets/icon/reset-btn-icon.svg";
import saveIcon from "../../../../../assets/inventory/save-icon.svg";
import { Field, Form, Formik } from "formik";
import Select from "react-select";

const PrescriptionsToTransfer = () => {
  const [showDrugDetails, setShowDrugDetails] = useState(false);

  const [radioBtns, setRadioBtns] = useState("fax");

  const medicineData = [
    {
      id: "one",
      medicineName: "Lisinopril 10mg Tablet",
      prescitptionNumkey: "Prescription Number:",
      prescitptionNumValue: "6373674",
      rxNumberKey: "Rx#:",
      rxNumberValue: "123456787",
      refillRemainingkey: "Refill Remaining:",
      refillRemainingValue: 3,
      qtyRemainingKey: "Qty Remaining:",
      qtyRemainingValue: 60,
    },
    {
      id: "two",
      medicineName: "Metformin 500mg Tablet",
      prescitptionNumkey: "Prescription Number",
      prescitptionNumValue: "4858522",
      rxNumberKey: "Rx#",
      rxNumberValue: "09876543",
      refillRemainingkey: "Refill Remaining",
      refillRemainingValue: 5,
      qtyRemainingKey: "Qty Remaining",
      qtyRemainingValue: 120,
    },
  ];

  const toggle = (id) => {
    setShowDrugDetails((prevId) => (prevId === id ? null : id));
  };

  return (
    <div className="p-3 pt-0 prescription-to-tranfer-container">
      <div>
        <PatientsDemographic
          fullName="John, Doe"
          firstName="John"
          lastName="Doe"
          dob="01/08/1996 (28Years)"
          phone="(555) 123-1234"
        />
        <div className="prescription-to-tranfer-data">
          {medicineData.map((details) => (
            <div
              className="prescription-tarnsfer cursor-pointer"
              onClick={() => toggle(details.id)}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div className="prescription-tarnsfer-title">
                  {details.medicineName}
                </div>
                <div>
                  <img
                    className="cursor-pointer"
                    src={doubleArrow}
                    style={{
                      transform:
                        showDrugDetails == details.id ? "rotate(180deg)" : "",
                      transition: "opacity 0.3s ease, transform 0.3s ease",
                    }}
                  />
                </div>
              </div>
              {showDrugDetails == details.id ? (
                <>
                  <div>
                    <div className="medication-divider-line mt-0"></div>
                    <Row>
                      <Col>
                        <div className="prescription-tarnsfer-head">
                          Rx Number
                        </div>
                        <div className="prescription-tarnsfer-popup">
                          1234567
                        </div>
                      </Col>
                      <Col>
                        <div className="prescription-tarnsfer-head">
                          Dipense Date
                        </div>
                        <div className="prescription-tarnsfer-popup">
                          02/14/2025
                        </div>
                      </Col>
                      <Col>
                        <div className="prescription-tarnsfer-head">
                          Fill Number
                        </div>
                        <div className="prescription-tarnsfer-popup">2</div>
                      </Col>
                      <Col>
                        <div className="prescription-tarnsfer-head">
                          Transaction Type
                        </div>
                        <div className="prescription-tarnsfer-popup pl-0">
                          Dispense
                        </div>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col>
                        <div className="prescription-tarnsfer-head">
                          Drug Name
                        </div>
                        <div className="prescription-tarnsfer-popup">
                          Lisinopril 10 MG Tablet
                        </div>
                      </Col>
                      <Col>
                        <div className="prescription-tarnsfer-head">NDC</div>
                        <div className="prescription-tarnsfer-popup">
                          6818051809
                        </div>
                      </Col>
                      <Col>
                        <div className="prescription-tarnsfer-head">
                          Manufacturer
                        </div>
                        <div className="prescription-tarnsfer-popup">
                          Lupin Pharma
                        </div>
                      </Col>
                      <Col>
                        <div className="prescription-tarnsfer-head">DAW</div>
                        <div className="prescription-tarnsfer-popup pl-0">
                          0-Not Specified
                        </div>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col>
                        <div className="prescription-tarnsfer-head">
                          Refills Remaining
                        </div>
                        <div className="prescription-tarnsfer-popup">3</div>
                      </Col>
                      <Col>
                        <div className="prescription-tarnsfer-head">
                          Quantity
                        </div>
                        <div className="prescription-tarnsfer-popup">30 EA</div>
                      </Col>
                      <Col>
                        <div className="prescription-tarnsfer-head">
                          Days Supply
                        </div>
                        <div className="prescription-tarnsfer-popup">30</div>
                      </Col>
                      <Col>
                        <div className="prescription-tarnsfer-head">
                          Written Date
                        </div>
                        <div className="prescription-tarnsfer-popup pl-0">
                          02/12/2025
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="medication-divider-line"></div>
                  <div>
                    <Row className="mt-2">
                      <Col>
                        <div className="prescription-tarnsfer-head">
                          Direction
                        </div>
                        <div className="prescription-tarnsfer-popup">
                          Take 1 tablet by mouth
                        </div>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col>
                        <div className="prescription-tarnsfer-head">Dose</div>
                        <div className="prescription-tarnsfer-popup">1 EA</div>
                      </Col>
                      <Col>
                        <div className="prescription-tarnsfer-head">
                          Times/Day
                        </div>
                        <div className="prescription-tarnsfer-popup">2</div>
                      </Col>
                      <Col>
                        <div className="prescription-tarnsfer-head">
                          Times/Day
                        </div>
                        <div className="prescription-tarnsfer-popup">
                          Morning (09:00), Evening (21:00)
                        </div>
                      </Col>
                      <Col>
                        <div className="prescription-tarnsfer-head">
                          Interval
                        </div>
                        <div className="prescription-tarnsfer-popup">
                          02/16/2025-03/16/2025
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="medication-divider-line"></div>
                  <Row className="mt-2">
                    <Col>
                      <div className="prescription-tarnsfer-head">
                        Prescriber Name
                      </div>
                      <div className="prescription-tarnsfer-popup">
                        Smith Robert
                      </div>
                    </Col>
                    <Col>
                      <div className="prescription-tarnsfer-head">NPI</div>
                      <div className="prescription-tarnsfer-popup">
                        182849801
                      </div>
                    </Col>
                    <Col>
                      <div className="prescription-tarnsfer-head">
                        Office Address
                      </div>
                      <div className="prescription-tarnsfer-popup">
                        1234 Maple RD, Anytown, USA
                      </div>
                    </Col>
                    <Col>
                      <div className="prescription-tarnsfer-head">
                        Phone Number
                      </div>
                      <div className="prescription-tarnsfer-popup">
                        (555) 987-6543
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                <div>
                  <span className="prescription-tarnsfer-head">
                    {details.prescitptionNumkey}
                  </span>
                  <span className="prescription-tarnsfer-data">
                    {details.prescitptionNumValue}
                  </span>
                  <span className="prescription-tarnsfer-border"></span>
                  <span className="prescription-tarnsfer-head">
                    {details.rxNumberKey}
                  </span>
                  <span className="prescription-tarnsfer-data">
                    {details.rxNumberValue}
                  </span>
                  <span className="prescription-tarnsfer-border"></span>
                  <span className="prescription-tarnsfer-head">
                    {details.refillRemainingkey}
                  </span>
                  <span className="prescription-tarnsfer-data">
                    {details.refillRemainingValue}
                  </span>
                  <span className="prescription-tarnsfer-border"></span>
                  <span className="prescription-tarnsfer-head">
                    {details.qtyRemainingKey}
                  </span>
                  <span className="prescription-tarnsfer-data">
                    {details.qtyRemainingValue}
                  </span>
                </div>
              )}
            </div>
          ))}
          <div className="medication-divider-line"></div>
          <div className="prescription-fax-verbal">
            <Row className="fax-heading">
              <Col>Method</Col>
            </Row>
            <Formik initialValues={{ picked: radioBtns }}>
              {({ setFieldValue }) => (
                <Form>
                  <Row className="prescription-form">
                    <Col lg="4">
                      <Field
                        type="radio"
                        name="picked"
                        value="fax"
                        checked={radioBtns === "fax"}
                        onChange={(e) => {
                          setRadioBtns(e.target.value);
                          setFieldValue("picked", e.target.value);
                        }}
                      />
                      <span className="ms-2">Fax</span>{" "}
                    </Col>
                    <Col lg="4">
                      <Field
                        type="radio"
                        name="picked"
                        value="verbal"
                        checked={radioBtns === "verbal"}
                        onChange={(e) => {
                          setRadioBtns(e.target.value);
                          setFieldValue("picked", e.target.value);
                        }}
                      />
                      <span className="ms-2">Verbal</span>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </div>
          <div style={{ marginLeft: "6px" }}>
            <Row className="mt-3">
              <Col className="p-0 pe-3">
                <div className="fax-heading">Pharmacy Name </div>
                <div className="marginTop16">
                  <InputGroup>
                    <Input placeholder="Enter Name" />
                  </InputGroup>
                </div>
              </Col>
              <Col className="p-0 pe-3">
                <div className="fax-heading">Address </div>
                <div className="marginTop16">
                  <InputGroup>
                    <Input placeholder="Enter Address" />
                  </InputGroup>
                </div>
              </Col>
              <Col className="p-0 pe-3">
                <div className="fax-heading">City </div>
                <div className="marginTop16">
                  <Select
                    className="dropdown-options"
                    // name="gender"
                    // value={GenderOptions.find(
                    //   (option) => option.value === data.gender
                    // )}
                    options={[
                      {
                        value: "chicago",
                        label: "Chicago",
                      },
                      {
                        value: "springfield",
                        label: "Spring Field",
                      },
                      {
                        value: "rockford",
                        label: "Rock Ford",
                      },
                    ]}
                    placeholder="Select City"
                    // onChange={handleOptionsChange}
                  />
                </div>
              </Col>
              <Col className="p-0">
                <div className="fax-heading">State </div>
                <div className="marginTop16">
                  <Select
                    className="dropdown-options"
                    // name="gender"
                    // value={GenderOptions.find(
                    //   (option) => option.value === data.gender
                    // )}
                    options={[
                      {
                        value: "newjersy",
                        label: "Jercy City",
                      },
                      {
                        value: "illinois",
                        label: "Illinois",
                      },
                      {
                        value: "newyork",
                        label: "New York",
                      },
                    ]}
                    placeholder="Select State"
                    // onChange={handleOptionsChange}
                  />
                </div>
              </Col>
            </Row>
          </div>
          <div style={{ marginLeft: "6px" }}>
            <Row className="mt-3">
              <Col className="p-0 pe-3">
                <div className="fax-heading">Zip/ Postal Code </div>
                <div className="marginTop16">
                  <InputGroup>
                    <Input placeholder="Enter Zip Code" />
                  </InputGroup>
                </div>
              </Col>
              <Col className="p-0 pe-3">
                <div className="fax-heading">
                  <span className="text-danger">*</span>Phone{" "}
                </div>
                <div className="marginTop16">
                  <InputGroup>
                    <Input placeholder="Enter Phone Number" />
                  </InputGroup>
                </div>
              </Col>
              <Col className="p-0 pe-3">
                <div className="fax-heading">Fax </div>
                <div className="marginTop16">
                  <InputGroup>
                    <Input placeholder="Enter Fax" />
                  </InputGroup>
                </div>
              </Col>
              <Col className="p-0">
                <div className="fax-heading">
                  <span className="text-danger">*</span> RPH Name{" "}
                </div>
                <div className="marginTop16">
                  <InputGroup>
                    <Input placeholder="Enter Reasons" />
                  </InputGroup>
                </div>
              </Col>
            </Row>
          </div>
          <div style={{ marginLeft: "6px" }}>
            <Row className="mt-3">
              <Col className="p-0 pe-3">
                <div className="fax-heading">Reason for Tranfer </div>
                <div className="marginTop16">
                  <InputGroup>
                    <Input placeholder="Enter Reason" />
                  </InputGroup>
                </div>
              </Col>
            </Row>
          </div>
          <div style={{ marginLeft: "6px" }}>
            <Row className="mt-3">
              <Col className="p-0 pe-3">
                <div className="fax-heading">Comments </div>
                <div className="marginTop16">
                  <FormGroup className="controls mb-0">
                    <Input
                      className="textlength"
                      name="directions"
                      type="textarea"
                      // value={directions}
                      // onChange={handleChangeDirections}
                      placeholder="Enter Directions"
                    />
                  </FormGroup>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div className="medication-prescription-footer">
        <Button color="primary" className="reset">
          <img src={resetIcon} /> Reset
        </Button>
        {radioBtns == "fax" ? (
          <Button color="primary">
            <img src={saveIcon} />
            Send Fax Transfer
          </Button>
        ) : (
          <Button color="primary">
            <img src={saveIcon} /> Confirm Verbal Tranfer
          </Button>
        )}
      </div>
    </div>
  );
};

export default PrescriptionsToTransfer;
